var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":"About"}},[(this.$store.state.langchange)?_c('div',[_vm._v(_vm._s(_vm.updatedata()))]):_vm._e(),_c('div',{staticClass:"container",domProps:{"innerHTML":_vm._s(_vm.DBitems)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }